export const fetchAllPages = apiCall => {
  return apiCall
    .then(
      response => {

        if(!response._paging)
          return Promise.resolve(response);

        let promises = [];
        const pages = +(response._paging.totalPages);

        if(pages > 1){
          promises = Array.from('0'.repeat(pages - 1)).map( (v,i) => apiCall.page(i+1));
        }

        promises.unshift(Promise.resolve(response));

        return Promise
          .all(promises)
          .then(
            responses => {
              const result = [];

              responses.forEach( response => {
                Array.prototype.push.apply(result, response);
              });

              return Promise.resolve(result);
            },
            error => {
              console.log("Paging fetch failed", error);
              return Promise.resolve(response);
            }
          );
      },
      error => {
        console.log("Initial fetch failed", error);
      }
    );
};



// WEBPACK FOOTER //
// ./src/util/wpapi_util.js